export default theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: '250px',
  },
  dialog: {},
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});
